import addOnFeatureSubscriptionsReducer from "reduxSlices/addOnFeatureSubscriptionsSlice"
import answerOptionsListsReducer from "reduxSlices/answerOptionsListsSlice"
import adminFacilityReducer from "reduxSlices/adminFacilitySlice"
import categoriesReducer from "reduxSlices/categoriesSlice"
import categoryReducer from "reduxSlices/categorySlice"
import currentSettingsReducer from "reduxSlices/currentSettingsSlice"
import customNamesReducer from "reduxSlices/customNamesSlice"
import facilitiesReducer from "reduxSlices/facilitiesSlice"
import featureAnnouncementReducer from "reduxSlices/featureAnnouncementSlice"
import featuresReducer from "reduxSlices/featuresSlice"
import formBuilderReducer from "reduxSlices/formBuilderSlice"
import formIndexReducer from "reduxSlices/formIndexSlice"
import formSubmissionAttachmentsGroupingReducer from "reduxSlices/formSubmissionAttachmentsGroupingSlice"
import formSubmissionConversationsReducer from "reduxSlices/formSubmissionConversationsSlice"
import formSubmissionResolutionReducer from "reduxSlices/formSubmissionResolutionSlice"
import formSubmissionReducer from "reduxSlices/formSubmissionSlice"
import formSubmissionTableReducer from "reduxSlices/formSubmissionTableSlice"
import groupsReducer from "reduxSlices/groupsSlice"
import organizationUsersSlice from "reduxSlices/organizationUsersSlice"
import questionTagsReducer from "reduxSlices/questionTagsSlice"
import reportBuilderReducer from "reduxSlices/reportBuilderSlice"
import reportIndexReducer from "reduxSlices/reportIndexSlice"
import SAMLConfigurationsReducer from "reduxSlices/SAMLConfigurationsSlice"
import sessionReducer from "reduxSlices/sessionSlice"
import surveyBatchTableReducer from "reduxSlices/surveyBatchTableSlice"
import surveyRecipientTableReducer from "reduxSlices/surveyRecipientTableSlice"
import taskReportBuilderReducer from "reduxSlices/taskReportBuilderSlice"
import tasksReducer from "reduxSlices/taskDraftAnswersSlice"
import taskTableReducer from "reduxSlices/taskTableSlice"
import workflowsReducer from "reduxSlices/workflowsSlice"
import { configureStore } from "@reduxjs/toolkit";

export const store = configureStore({
  reducer: {
    addOnFeatureSubscriptions: addOnFeatureSubscriptionsReducer,
    answerOptionsLists: answerOptionsListsReducer,
    adminFacility: adminFacilityReducer,
    categories: categoriesReducer,
    category: categoryReducer,
    currentSettings: currentSettingsReducer,
    customNames: customNamesReducer,
    facilities: facilitiesReducer,
    featureAnnouncement: featureAnnouncementReducer,
    features: featuresReducer,
    formBuilder: formBuilderReducer,
    formIndex: formIndexReducer,
    formSubmission: formSubmissionReducer,
    formSubmissionAttachmentsGrouping: formSubmissionAttachmentsGroupingReducer,
    formSubmissionConversations: formSubmissionConversationsReducer,
    formSubmissionResolution: formSubmissionResolutionReducer,
    formSubmissionTable: formSubmissionTableReducer,
    groups: groupsReducer,
    organizationUsers: organizationUsersSlice,
    questionTags: questionTagsReducer,
    reportBuilder: reportBuilderReducer,
    reportIndex: reportIndexReducer,
    SAMLConfigurations: SAMLConfigurationsReducer,
    session: sessionReducer,
    surveyBatchTable: surveyBatchTableReducer,
    surveyRecipientTable: surveyRecipientTableReducer,
    taskReportBuilder: taskReportBuilderReducer,
    tasks: tasksReducer,
    taskTable: taskTableReducer,
    workflows: workflowsReducer,
  },
});
